import React from 'react';
import { NavLink } from 'react-router-dom';
import '../assets/styles/components/MenuInternal.sass';

const MenuCali = () => (
  <div className="row MenuInternal -cali">
    <div className="container">
      <div className="row">
        <div className="col-12">
          <ul className="MenuInternal__list">
            {/* <li className="MenuInternal__list--item">
              <NavLink to="/cali/registro">
                REGISTRO
              </NavLink>
            </li> */}
            <li className="MenuInternal__list--item">
              <NavLink to="/cali/acerca-de-la-carrera">
                SERIES CALI RESUMEN
              </NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <NavLink id="que-incluye" to="/cali/precios-que-incluye">
                PRECIOS Y QUÉ INCLUYE
              </NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <NavLink to="/cali/categorias-y-rutas">
                CATEGORÍAS Y RUTAS
              </NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <NavLink to="/cali/premiacion-y-reglamento">
                PREMIACIÓN Y REGLAMENTO
              </NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <NavLink to="/cali/patrocinio-expo">
                PATROCINIO Y EXPO
              </NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <NavLink to="/cali/galeria">
                GALERIA
              </NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <NavLink to="/cali/resultados">
                RESULTADOS
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
)
  
export default MenuCali;